import { Pipe, PipeTransform } from '@angular/core';
import { FormatService } from '../../services/format.service';
import { UNIT } from '../../models/types';

@Pipe({
  name: 'formatValue'
})
export class FormatValuePipe implements PipeTransform {
  constructor(public formatService: FormatService) {}

  transform(value: number, unit: UNIT, fallback: number = 0): number {
    return this.formatService.formatValue(value, unit, fallback);
  }
}
